function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M3.136 7.1l14.448 14.447-1.033 1.032-2.598-2.599a.936.936 0 01-.459.153H3.709a.786.786 0 01-.803-.804V11.15c0-.459.344-.803.803-.803h.612L2.104 8.131 3.136 7.1zm14.448 3.669v8.714l-9.135-9.134h5.045c.459 0 .84.344.84.803v2.866l3.25-3.249zM14.688.818l8.164 8.165-.584.583L20.8 8.098a.536.536 0 01-.26.086h-5.528a.444.444 0 01-.454-.454V3.108c0-.26.195-.454.454-.454h.345l-1.253-1.253.584-.583zm8.164 2.074v4.924L17.69 2.654h2.851c.26 0 .476.194.476.454v1.619l1.835-1.835z"
});

var SvgMuteVideoEveryoneElse = function SvgMuteVideoEveryoneElse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), _ref);
};

export default SvgMuteVideoEveryoneElse;